import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Table, TableBody } from '@/component-style/Table';
import TableWrapper  from '@/components/UI/TableWrapper';
import PageSelector from '@/components/UI/PageSelector';
import Header from './Header';
import Item from './Item';

const TableLeaveApplication = props => {
  const { leaveApplicationRecords, leaveSettinsOptions } = props;
  const history = useHistory();
  const attendanceRoutes = useSelector(state => state.login.attendanceRoutes);
  const disableDetailPage = attendanceRoutes.indexOf('OvertimeDetail') === -1;

  return (
    <TableWrapper title = { `休假申請列表 (${props.searchLeaveFrom}~${props.searchLeaveEnd})` }>
      <Table>
        <Header/>
        <TableBody>
          {
            leaveApplicationRecords.map(leaveApplicationRecord =>
              <Item
                key = { leaveApplicationRecord.workingHoursID }
                leaveApplicationRecord = { leaveApplicationRecord }
                leaveSettinsOptions = { leaveSettinsOptions }
                disableDetailPage = { disableDetailPage }
                goDetailHandler = {() => {
                  history.push(`/Attendance/LeaveDetail/${leaveApplicationRecord.id}`);
                }}
              />
            )
          }
        </TableBody>
      </Table>
      <PageSelector
        current = { props.currentPage }
        total = { props.totalCount }
        pageChangedHandler = { props.pageChangedHandler }
      />
    </TableWrapper>
  );
};

export default TableLeaveApplication;
